import isObject from "lodash/isObject";
import isString from "lodash/isString";

// 一覧表のタスクのデータから船名を取得する
export const calcTaskVesselName = (
  taskData, // destinationWorkTasksMap[date][taskId]( {docData: {vessel_name: string} | undefined} )
) => {
  if (!isObject(taskData)) return "";
  if (!isObject(taskData.docData)) return "";
  if (!isString(taskData.docData.vessel_name)) return "";
  return taskData.docData.vessel_name || "";
};

// 船舶マスタのデータから船名を取得する
export const calcVesselMasterVesselName = (
  vesselsMaster, // vesselsData[index] ( {data: {name: string} | undefined} )
) => {
  if (!isObject(vesselsMaster)) return "";
  if (!isObject(vesselsMaster.data)) return "";
  if (!isString(vesselsMaster.data.name)) return "";
  return vesselsMaster.data.name || "";
};

// 船舶マスタとタスクの船名が一致するかどうか判定する
export const isSameTaskVesselNameAndMasterVesselName = (
  taskData, // destinationWorkTasksMap[date][taskId]( {docData: {vessel_name: string} | undefined} )
  vesselsMaster, // vesselsData[index] ( {data: {name: string} | undefined} )
) => {
  const taskVesselName = calcTaskVesselName(taskData);
  const masterVesselName = calcVesselMasterVesselName(vesselsMaster);
  return taskVesselName === masterVesselName; // boolean
};

// 引数の obj がマスタに登録されている port の条件を満たすかどうか判定する
export const isPort = (
  obj, // masterMap.ports[index]
) => {
  if (!isObject(obj)) return false;
  const { id, label } = obj;
  const isValidId = isString(id) && id.length > 0;
  const isValidLabel = isString(label) && label.length > 0;
  return isValidId && isValidLabel;
};

// stateのvesselsDataからdropdownのoptionのリストを作成する
export const createVesselOptions = (
  vesselsData, // VesselsData
) => {
  if (!Array.isArray(vesselsData)) {
    return [];
  }
  return vesselsData
    .filter((vessel) => {
      if (!(isObject(vessel) && isObject(vessel.data))) return false;
      return isString(vessel.data.id) && isString(vessel.data.name);
    })
    .map((vessel) => {
      const vesselOption = createVesselOption(vessel);
      return vesselOption;
    });
};

// dropdownのoptionのリストの要素を作成
export const createVesselOption = (
  vesselsMaster, // vesselsData[index] ( {data: {name: string} | undefined} )
) => {
  const { data } = vesselsMaster;
  const vesselOption = {
    id: data.id,
    label: data.name,
  };
  return vesselOption;
};
